import React, { useState } from 'react';
import PrimaryButton from '../Buttons/PrimaryButton';

const Step5 = ({ onPaymentMethodSelect, setIsCardPayment, onBack }) => {
    const [paymentMethod, setPaymentMethod] = useState(null);

    const handleMethodSelect = (method) => {
        setPaymentMethod(method);
        onPaymentMethodSelect(method);
        if (method === "card") {
            setIsCardPayment(true)
        } else {
            setIsCardPayment(false)
        }
    };

    return (
        <div className="step-5">
            <h2 className="text-lg font-bold mb-4">Choisissez votre moyen de paiement</h2>
            <div className="flex flex-wrap gap-x-[20px]">
                <button
                    type='button'
                    onClick={() => handleMethodSelect('mobile_money')}
                    className={`p-[10px] bg-gray-100 border rounded-xl ${paymentMethod === 'mobile_money' ? 'selected' : ''}`}>
                    Mobile Money
                </button>
                <button
                    type='button'
                    onClick={() => handleMethodSelect('card')}
                    className={`p-[10px] bg-gray-100 border rounded-xl ${paymentMethod === 'card' ? 'selected' : ''}`}>
                    Carte
                </button>
            </div>

            {paymentMethod === 'mobile_money' && (
                <p className="mt-4">Vous avez sélectionné Mobile Money. Cliquez sur Suivant pour choisir un opérateur.</p>
            )}
            {paymentMethod === 'card' && (
                <p className="mt-4">Vous avez sélectionné Carte. Cliquez sur Suivant pour procéder.</p>
            )}
            <PrimaryButton type='button' onClick={onBack} label={"Retour"} className="bg-gray-300 py-2 px-4 rounded mr-2" />
        </div>
    );
};

export default Step5;
